import React from "react";
import { useHistory } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import Popover from "react-bootstrap/Popover";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { clickifyPhoneNumber, capitalizeFirstLetter } from "Utils/Utils";
import { useMediaQuery } from 'react-responsive';
import Menu from "Components/Menu/Menu";
import useVipAccountCache from "Utils/Hooks/useVipAccountCached";
import useSession from "Utils/Hooks/useSession";
import useMode from "Utils/Hooks/useMode";
import { PRODUCTTYPES } from "Utils/Constants";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";

import VIPPreferredLogo from "Assets/Img/vipp-logo.png";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import arrowback from "Assets/Icons/arrow-back.svg";
import help from "Assets/Icons/help.svg";
import profile from "Assets/Icons/profile.svg";
import "./Header.scss";
import { faro } from "@grafana/faro-react";

const Header = ({ back=true, isEnrollment=false }) => {
  const mode = useMode();
  const { session, invalidateSession } = useSession();
  const isVIPPreferred = session?.patronProductType === PRODUCTTYPES.PREFERRED;
  const productType = isVIPPreferred ? 'VIP Preferred' : 'VIP Online';
  const logoSrc = isVIPPreferred ? VIPPreferredLogo : VIPOnlineLogo;
  const { vipAccount } = useVipAccountCache();
  const vipApi = useVipApiFetcher();
  const isMobile = useMediaQuery({
    query: '(max-width: 767.98px)'
  });
  let history = useHistory();
  const userName = `${capitalizeFirstLetter(vipAccount?.firstName)} ${capitalizeFirstLetter(vipAccount?.lastName)}`;
  const logout = async () => {
    await NotifyLogout();
  };
  const dashboardClick = () => {
    history.push('dashboard');
    faro.api.pushEvent("User clicked on Dashboard");
  }
  const backClick = () => {
    history.goBack();
    faro.api.pushEvent("User clicked back button from Header");
  };
  const helpMessage = <div className="text-center">
    <div>Need support? Call CAMS</div>
    <div className="phone">{clickifyPhoneNumber('1-800-500-1973')}</div>
  </div>
  const helpPopover = <Popover>
                    <Popover.Body>
                      {helpMessage}
                    </Popover.Body>
                  </Popover>;

  const profileMessaage = <div className="text-center">
    <div>Welcome, {userName}!</div>
    <button className="logout click-menu-logout" onClick={logout}>Close {productType}</button>
  </div>
  const profilePopover = <Popover>
                    <Popover.Body>
                      {profileMessaage}
                    </Popover.Body>
                  </Popover>;
  const logo = <div onClick={dashboardClick}><img className="vip-preferred" src={logoSrc} alt={productType} /></div>;
  const backButton = <Button variant="Link" className="back-button click-back-button" onClick={backClick}><img alt="Go back" src={arrowback} /></Button>;
  const helpButton = <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={helpPopover}>
                      <Button className="float-right" variant="Link"><img className="top-menu-icon" alt="Help" src={help} /></Button>
                    </OverlayTrigger>;
  const profileButton = <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={profilePopover}>
                      <Button className="float-right" variant="Link"><img className="top-menu-icon" alt="Profile" src={profile} /></Button>
                    </OverlayTrigger>;

  if(!mode && session) {
    history.push("/invalid");
  }

  async function NotifyLogout() {
    const sessionId = JSON.parse(global.sessionStorage.getItem("vip-patron-session")).sessionId;
    if (!session.transactionSucceeded) {
      vipApi
        .fetch("/api/usertracking/cancelflow", "POST", {
          transactionStage: mode === "withdraw" ? "Withdrawal" : "Deposit",
          sessionId: sessionId,
        })
        .then((response) => {
          if (response.ok) {
            faro.api.pushEvent("User logged out");
            invalidateSession();
            history.push("/logout");
          } else {
            faro.api.pushError(new Error("Logout Request Error"), { context: response });
            if (response.status === 500) {
              console.error(response.statusText);
              history.push({
                pathname: "/error",
              });
            } else if (response.status === 401) {
              console.error(response.statusText);
              history.push({
                pathname: "/expired",
              });
            } else {
              response.json().then((data) => {
                console.error(data);
                onError(data);
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          faro.api.pushError(new Error("Logout Network Error"), { context: error });
          history.push({
            pathname: "/error",
          });
        });
    } else {
      invalidateSession();
      history.push("/logout");
    }
  }

  function onError(response) {
    history.push({
      pathname: '/error',
      state: {
        isError: true,
        showButton: true,
        title: "Request Failed. Please Try Again",
        message: response.patronErrorMessage ?? "We are unable to complete this request. Please contact our Customer Service Team at 1-800-500-1973. Reference code E-30 so that we may better serve you.",
        allowRetry: false
      }
    });
  }

  return (
    logo && <div className="header">
      {isMobile && <><Menu firstName={vipAccount?.firstName} lastName={vipAccount?.lastName} />
        <Row>
          <Col xs={3}>{back && backButton}</Col>
          <Col xs={6}>{logo}</Col>          
        </Row>
      </>}
      {!isMobile && <Row>
        <Col>{back && backButton}</Col>
        <Col>{logo}</Col>
        <Col>
          {!isEnrollment && profileButton}
          {!isEnrollment && helpButton}
        </Col>
      </Row>}
    </div>
  );
};

export default Header;